import {
  Avatar,
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import routes from "../routes/router";
import image from "../assets/images/omar.jpg";
import ChangeTheme from "../components/common/changeTheme";
import { getRandomColor } from "../utils/randomColor";
import { uiConfig } from "../configs/uiConfig";
import { Helmet } from "react-helmet";
import logo from "../assets/images/logo.png"

const Home = () => {
  const theme = useTheme();

  return (
    <Container
      sx={{
        width: "600px",
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "space-between",
        gap: "20px",
      }}
    >
      <Helmet>
        <title>Omar alghaish</title>
        <meta
          name="description"
          content="omar alghaish software engineer and web developer"
        />
        <meta
          name="keywords"
          content="omar, omar alghaish, omar elghaish,alghaish,elghaish,engineer, software engineer, sofrware, web developer,frontend developer,backend developer, node , react, HTML, CSS, JavaScript"
        />
         <link rel="icon" type="image/x-icon" href={logo} />
      </Helmet>
      <Box>
        <Avatar
          variant="square"
          alt="OMAR ALGHAISH"
          src="https://avatars.githubusercontent.com/u/96939501?v=4"
          sx={{ width: 100, height: 100 }}
        />

        <Box
          height="5px"
          width="100px"
          sx={{ background: uiConfig.linearBackground("90deg") }}
        />
      </Box>

      <Box marginY="30px">
        <Typography variant component="h1">
          Hi, Iam Omar Alghaish
        </Typography>
        <Typography variant="body2">
          A software engineer with basic khowledge of software design,
          development and testin. Seeking to benefit from a broad educational
          background with excellent analyical, technical and programming skills,
          and rely heavily on self-learning in addition to university education
          to develop my skills, and intersted in web desigening and developing
        </Typography>
      </Box>

      <Stack gap="10px">
        {routes.map((route) => (
          <Stack
            direction="row"
            sx={{
              position: "relative",
              "&:hover .decoration ": {
                width: "100%",
                height: "100%",
                position: "absolute",
                left: "0",
                top: "0",
              },
            }}
          >
            <Box
              className="decoration"
              sx={{
                background: getRandomColor(),
                width: "5px",
                transition: ".8s",
              }}
            />
            <Button
              className="linkButton"
              startIcon={route.icon}
              fullWidth={true}
              style={{ justifyContent: "flex-start" }}
              component={Link}
              to={route.path}
              sx={{ flexGrow: "1", borderRadius: "none" }}
              variant=""
            >
              {route.state}
            </Button>
          </Stack>
        ))}
      </Stack>
    </Container>
  );
};

export default Home;
